import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type UserAccountStatusQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserAccountStatusQuery = {
  __typename?: 'Query';
  user: { __typename?: 'User'; id: string; hasAcceptedTerms: boolean };
};

export type SendVerificationEmailMutationVariables = Types.Exact<{
  inputs: Types.SendVerificationEmailInputs;
}>;

export type SendVerificationEmailMutation = {
  __typename?: 'Mutation';
  sendVerificationEmail: {
    __typename?: 'SendVerificationEmailMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type AcceptUserTermsMutationVariables = Types.Exact<{ [key: string]: never }>;

export type AcceptUserTermsMutation = {
  __typename?: 'Mutation';
  acceptUserTerms: {
    __typename?: 'AcceptUserTermsMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export const UserAccountStatusDocument = gql`
  query UserAccountStatus {
    user {
      id
      hasAcceptedTerms
    }
  }
`;

/**
 * __useUserAccountStatusQuery__
 *
 * To run a query within a React component, call `useUserAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAccountStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserAccountStatusQuery,
    UserAccountStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserAccountStatusQuery, UserAccountStatusQueryVariables>(
    UserAccountStatusDocument,
    options
  );
}
export function useUserAccountStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAccountStatusQuery,
    UserAccountStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserAccountStatusQuery, UserAccountStatusQueryVariables>(
    UserAccountStatusDocument,
    options
  );
}
export type UserAccountStatusQueryHookResult = ReturnType<
  typeof useUserAccountStatusQuery
>;
export type UserAccountStatusLazyQueryHookResult = ReturnType<
  typeof useUserAccountStatusLazyQuery
>;
export type UserAccountStatusQueryResult = Apollo.QueryResult<
  UserAccountStatusQuery,
  UserAccountStatusQueryVariables
>;
export const SendVerificationEmailDocument = gql`
  mutation SendVerificationEmail($inputs: SendVerificationEmailInputs!) {
    sendVerificationEmail(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type SendVerificationEmailMutationFn = Apollo.MutationFunction<
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables
>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSendVerificationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >(SendVerificationEmailDocument, options);
}
export type SendVerificationEmailMutationHookResult = ReturnType<
  typeof useSendVerificationEmailMutation
>;
export type SendVerificationEmailMutationResult =
  Apollo.MutationResult<SendVerificationEmailMutation>;
export type SendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables
>;
export const AcceptUserTermsDocument = gql`
  mutation AcceptUserTerms {
    acceptUserTerms {
      code
      success
      message
    }
  }
`;
export type AcceptUserTermsMutationFn = Apollo.MutationFunction<
  AcceptUserTermsMutation,
  AcceptUserTermsMutationVariables
>;

/**
 * __useAcceptUserTermsMutation__
 *
 * To run a mutation, you first call `useAcceptUserTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserTermsMutation, { data, loading, error }] = useAcceptUserTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptUserTermsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUserTermsMutation,
    AcceptUserTermsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptUserTermsMutation, AcceptUserTermsMutationVariables>(
    AcceptUserTermsDocument,
    options
  );
}
export type AcceptUserTermsMutationHookResult = ReturnType<
  typeof useAcceptUserTermsMutation
>;
export type AcceptUserTermsMutationResult =
  Apollo.MutationResult<AcceptUserTermsMutation>;
export type AcceptUserTermsMutationOptions = Apollo.BaseMutationOptions<
  AcceptUserTermsMutation,
  AcceptUserTermsMutationVariables
>;
